export const isRainbowUser = () => localStorage.getItem("rainbow") === "1";
